import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const mobilityConcept = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      hero: {
        title: "Willkommen bei der Werkstatt-Buchung von {{organization}}",
        subtitle: null,
      },
      welcomeModal: {
        title: "Sie verlassen nun die Seite von {{organization}}",
        text: "Bitte beachten Sie, dass Sie sich auf einer Website befinden, für deren Inhalt {{organization}} nicht verantwortlich ist und die Datenschutzbestimmungen von {{organization}} keine Anwendung finden.",
      },
      hint: {
        text: "Alle gezeigten Partner sind von {{organization}} freigegeben. Bitte beachten Sie bei der Auswahl Ihre Fuhrparkvorgaben oder einzelvertraglichen Regelungen.",
      },
      contactForm: {
        "message-label-required": "Was möchten Sie der {{garageType}} mitteilen?",
        "message-label": "Was möchten Sie der {{garageType}} mitteilen?",
        placeholders: {
          message: "Bitte beschreiben Sie den nötigen Service (optional)",
          "message-required": "Bitte beschreiben Sie den nötigen Service",
        },
      },
      layout: {
        backText: "Zurück zu mobility-concept.de",
      },
      linkToHome: "https://werkstatt.repareo.de/partner/mobility-concept",
      benefits: {
        "bullet-point-3":
          "Exklusive Zusatzservices wie Hol- und Bring und Ersatzfahrzeug hinzufügen (ggf. können zusätzliche Kosten anfallen)",
        feedbackTitle: "Feedback",
      },
      contactFormMessages: {
        activeInquiryExistsForNumberplateErrorMessageTitle: "Sie haben bereits einen Termin",
        activeInquiryExistsForNumberplateAndServiceErrorMessageTitle:
          "Sie haben bereits einen Termin für diesen Service",
        returnDateNotReachedTitle: "Rückgabe ist zu früh geplant",
        returnDateNotReached: `Ihr Fahrzeug ist noch nicht für die Rückgabe freigegeben. <br/> Frühestes  Rückgabedatum: {{returnDate}}`,
        numberplateCorrect: "Kennzeichen stimmt",
        numberplateChange: "Kennzeichen ändern",
        numberplateNotFoundTitle: "Kennzeichen nicht gefunden",
        slotAlreadyTakenTitle: " Oh! Da war jemand schneller",
        nationwideServiceAddressHeadline: "Wo soll der Service durchgeführt werden?",
        numberplateNotFoundMessage: `Wir konnten Ihr Fahrzeug nicht im Mobility Concept Bestand finden. <br/> Bitte prüfen Sie das angegebene Kennzeichen oder kontaktieren Sie Mobility Concept. <br/> <b>Mobility Concept Fahrercenter</b> <br/> <a href="tel:+4989632660">+49 (0) 89 632 660</a>`,
      },
      booking: {
        headline: "Termin buchen",
        subheadline: "Service: {{service}}",
        "slot-taken-1": "Schade! Da war leider jemand schneller und hat deinen Wunschtermin am",
        "slot-taken-2": "reserviert. Bitte wähle einen anderen Termin.",
        "no-slots": "Leider sind für diese Werkstatt aktuell keine freien Termine verfügbar.",
        "no-slots-contact-phone": `Bitte kontaktieren Sie die Werkstatt direkt unter <tel>{{tel}}</tel>.`,
        "error-nearest-slot-gone":
          "Puh, die Werkstatt hat einiges zu tun: Der {{ day }} ist jetzt schon ausgebucht. Ab dem {{ newDay }} sind wieder Termine frei.",
        "next-free-slot": "Nächster freier Termin:",
        "chosen-slot": "Gewünschter Termin:",
        "please-choose-services": "Bitte wähle die gewünschten Services",
        "more-information-link": "Mehr zum Terminablauf",
        hint: `Die finale Terminbestätigung erfolgt durch die Prüfstelle.<br/>Bitte beachten Sie: Eine Rückgabe vor Ihrem Vertragsende kann zusätzliche Kosten verursachen (z. B. Verfall von Minderkilometern).`,
        blocking: "Termin wird reserviert...",
        submit: "Termin sichern",
        moreInformation: {
          headline: "Wie genau läuft der Termin ab?",
          "bullet-point-1": "Deine Buchung geht direkt in den Kalender der {{garageType}}.",
          "bullet-point-2": "Bitte gib dein Auto zu Beginn des Termins ab.",
          "bullet-point-3":
            "Die Werkstatt informiert dich telefonisch, sobald du dein Auto abholen kannst.",
          "bullet-point-4": "Du kannst deinen Termin jederzeit kostenfrei absagen.",
          "bullet-point-5": "",
          "bullet-point-6": "",
          "instant-booking":
            "Diese Werkstatt erhält deinen gebuchten Termin direkt in den Kalender. Somit ist der Termin sofort bestätigt.",
          "request-booking":
            "Diese Werkstatt erhält eine Terminanfrage und bestätigt deinen Wunschtermin so schnell wie möglich.",
        },
        vehicleReturn: {
          headline: "Termine",
          submit: "Termin auswählen",
        },
      },
      contractDetails: {
        hint: `<bold>Sie haben Ihr Auto ursprünglich von MeinAuto bezogen?</bold><br/>Dann
                nutzen Sie bitte diesen Link: <a>MeinAuto
                Fahrzeugrückgabe</a>`,
        error: {
          general: `Etwas ist schiefgegangen. Bitte schreiben Sie eine E-Mail an <a>werkstattmeister@repareo.de</a>`,
          not_found: `Wir konnten anhand Ihrer Vertragsdaten keinen Vertrag finden. Bitte überprüfen Sie Ihre Vertragsdaten oder schreiben Sie eine E-Mail an <a>MeinAuto-Rueckgabe@mobility-concept.de</a>.`,
          not_found_email: "MeinAuto-Rueckgabe@mobility-concept.de",
          does_not_match: `Die eingegebenen Daten passen nicht zum gefundenen Vertrag. Bitte überprüfen Sie Vertragsnummer und Kennzeichen oder schreiben Sie eine E-Mail an <a>MeinAuto-Rueckgabe@mobility-concept.de</a>.`,
          wrong_format: `Sie haben einen MeinAuto Vertrag? Dann nutzen Sie bitte diesen Link: <a>MeinAuto Fahrzeugrückgabe</a>`,
          cannot_book:
            "Zu früh dran! Der frühest mögliche Termin ist vier Wochen vor Vertragsende. Ab zwei Monate vor Vertragsende können Sie passende Termine einsehen und buchen.",
        },
      },
    },
  },
};
